import { render, staticRenderFns } from "./SlidebarReturnResult.vue?vue&type=template&id=400a2ad1&scoped=true"
import script from "./SlidebarReturnResult.vue?vue&type=script&lang=js"
export * from "./SlidebarReturnResult.vue?vue&type=script&lang=js"
import style0 from "./SlidebarReturnResult.vue?vue&type=style&index=0&id=400a2ad1&prod&lang=scss&scoped=true"
import style1 from "./SlidebarReturnResult.vue?vue&type=style&index=1&id=400a2ad1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400a2ad1",
  null
  
)

export default component.exports